module.exports = __webpack_public_path__ + "static/assets/c827b4622e3d5da21170b26bd6976688.png";